import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import {NativeDateAdapter} from '@angular/material/core';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import Swal from 'sweetalert2';
import { TransaccionService } from '../../services/transaccion.service';
import { CognitoService } from 'src/app/auth/services/cognito.service';
import { TransactionsReportGeneralService } from '../../services/transactions-report-general.service';
import { BalancesReportVesService } from '../../services/balances-report-ves.service';
@Component({
  selector: 'app-generate-cash-closing',
  template: `<p>generate-rcash-closing works!</p>`,
  styleUrls: ['./generate-cash-closing.component.sass'],
  templateUrl: './generate-cash-closing.component.html',
  providers: [NativeDateAdapter],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenerateCashClosingComponent {

  selectedDate: Date = new Date();
  selectedDateAC: Date = new Date();
  fechaInicio: Date = new Date();
  fechaFin: Date = new Date();
  fechaSaldosVe: Date = new Date();
  maxDate: Date;
  role = '';
  constructor(
    private spinner: SpinnerService,
    private transactionService: TransaccionService,
    private cognito: CognitoService,
    private reportService: TransactionsReportGeneralService,
    private balancesReportVesService: BalancesReportVesService
  ) {
    this.maxDate = new Date();
   this.getRole()
  }

  async getRole(){
   const user = await this.cognito.getUser();
    this.role = user.attributes['custom:user-group'];
  }

  closeCash() {
    const formatedDate = new Date(this.selectedDate).toISOString().split('T')[0];
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Esto sobreescribirá el cierre de caja anterior con la fecha indicada. ¿Deseas continuar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, cerrar',
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        const ref = this.spinner.start();
        try {
          await this.transactionService.reportTransactions(formatedDate);
          Swal.fire('Transacciones reportadas', '', 'success');
        } catch (error) {
          if ((error as any)?.error?.message) {
            Swal.fire('Error', (error as any)?.error?.message, 'error');
          }else{
            Swal.fire('Error', 'Ocurrió un error inesperado', 'error');
          }

        }
        this.spinner.stop(ref);
      }
    })
  }

  creditLineReport() {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Esto sobreescribirá el reporte de línea de crédito anterior. ¿Deseas continuar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, generar',
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        const ref = this.spinner.start();
        try {
          await this.transactionService.reportCreditLine();
          Swal.fire('Reporte generado', '', 'success');
        } catch (error) {
          if ((error as any)?.error?.message) {
            Swal.fire('Error', (error as any)?.error?.message, 'error');
          }else{
            Swal.fire('Error', 'Ocurrió un error inesperado', 'error');
          }

        }
        this.spinner.stop(ref);
      }
    })
  }

  ACReport() {
    const formatedDate = new Date(this.selectedDateAC).toISOString().split('T')[0];
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Esto sobreescribirá el reporte de línea de crédito anterior. ¿Deseas continuar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, generar',
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        const ref = this.spinner.start();
        try {
          await this.transactionService.reportAC(formatedDate);
          Swal.fire('Reporte generado', '', 'success');
        } catch (error) {
          if ((error as any)?.error?.message) {
            Swal.fire('Error', (error as any)?.error?.message, 'error');
          }else{
            Swal.fire('Error', 'Ocurrió un error inesperado', 'error');
          }

        }
        this.spinner.stop(ref);
      }
    })
  }

  downloadVesBalancesReport() {
    if (!this.fechaSaldosVe) {
      Swal.fire('Error', 'Por favor selecciona una fecha', 'error');
      return;
    }

    const fechaFormatted = new Date(this.fechaSaldosVe).toISOString().split('T')[0];

    const ref = this.spinner.start();

    this.balancesReportVesService.downloadAndSaveReport(
      { fecha: fechaFormatted },
      `saldos-usuarios-ve-${fechaFormatted}.xlsx`
    ).subscribe({
      next: () => {
        this.spinner.stop(ref);
        Swal.fire('Descarga exitosa', 'El archivo se ha descargado correctamente', 'success');
      },
      error: (error) => {
        this.spinner.stop(ref);
        const errorMessage = error?.message || 'Ocurrió un error al descargar el reporte';
        Swal.fire('Error', errorMessage, 'error');
      }
    });
  }

  downloadGeneralReport() {
    // Validar que las fechas estén seleccionadas
    if (!this.fechaInicio || !this.fechaFin) {
      Swal.fire('Error', 'Por favor selecciona ambas fechas', 'error');
      return;
    }

    // Validar que la fecha de inicio sea menor o igual a la fecha de fin
    if (this.fechaInicio > this.fechaFin) {
      Swal.fire('Error', 'La fecha de inicio debe ser menor o igual a la fecha de fin', 'error');
      return;
    }

    // Formatear fechas
    const fechaInicioFormatted = new Date(this.fechaInicio).toISOString().split('T')[0];
    const fechaFinFormatted = new Date(this.fechaFin).toISOString().split('T')[0];

    const ref = this.spinner.start();

    this.reportService.downloadAndSaveReport({
      fechaInicio: fechaInicioFormatted,
      fechaFin: fechaFinFormatted
    }, `reporte-transacciones-${fechaInicioFormatted}_${fechaFinFormatted}.csv`).subscribe({
      next: () => {
        this.spinner.stop(ref);
        Swal.fire('Descarga exitosa', 'El archivo se ha descargado correctamente', 'success');
      },
      error: (error) => {
        this.spinner.stop(ref);
        const errorMessage = error?.message || 'Ocurrió un error al descargar el reporte';
        Swal.fire('Error', errorMessage, 'error');
      }
    });
  }

 }
